var React = require('react');

function Heart32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M29.852 14.506c-.006.007-.007.016-.014.023L18.257 27.185a2.805 2.805 0 0 1-2.097.946h-.001a2.847 2.847 0 0 1-2.101-.949L2.485 14.529c-.006-.006-.008-.014-.013-.021-3.296-3.337-3.285-8.719.045-12.035 3.326-3.309 8.722-3.327 12.074-.06l.001.001 1.568 1.31 1.57-1.311.003-.002c3.353-3.265 8.747-3.247 12.073.062 3.326 3.316 3.338 8.696.046 12.033zM28.378 3.894c-2.562-2.546-6.726-2.545-9.285.002-.01.01-.025.014-.036.024-.012.011-.017.025-.029.035l-2.22 1.853c-.048.04-.106.061-.159.091-.037.02-.069.045-.107.06a.998.998 0 0 1-.382.083h-.001-.001a.997.997 0 0 1-.381-.083c-.039-.015-.072-.041-.109-.062-.053-.03-.109-.05-.158-.09l-2.216-1.852c-.011-.01-.016-.024-.027-.035-.011-.01-.026-.013-.037-.024-2.562-2.549-6.728-2.547-9.285 0a6.526 6.526 0 0 0 0 9.245c.006.006.007.013.013.019.006.006.014.008.02.015l11.577 12.656a.794.794 0 0 0 1.205.005l11.585-12.661c.006-.007.014-.009.02-.015s.007-.013.013-.019a6.532 6.532 0 0 0 0-9.247z","key":1})]);
}

Heart32px.displayName = "Heart32px";

Heart32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32.35 28.12"};

module.exports = Heart32px;

Heart32px.default = Heart32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/heart-32px.svg
// module id = 1102
// module chunks = 0